import React from "react";
import { Check } from "lucide-react";
import { HOST, ASSETS } from "../../mock";

const Host = () => {
  const scrollToForm = () => document.getElementById("register")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="host" className="py-28 border-t border-[#131c31] scroll-mt-24" data-testid="host-section">
      <div className="max-w-7xl mx-auto px-6">
        <p className="font-mono text-[10px] tracking-[0.35em] text-[#6f7d9f] uppercase mb-12 reveal">{HOST.label}</p>
        <div className="grid lg:grid-cols-[0.4fr_0.6fr] gap-12 items-start">
          <div className="reveal">
            <div className="relative corner-frame">
              <img src={ASSETS.oscar} alt="Oscar Tobar" className="w-full max-w-sm object-cover" data-testid="host-photo" />
            </div>
            <p className="mt-5 text-white font-semibold">Oscar Tobar</p>
            <p className="text-[#7f8db0] text-sm">Great Western Funding</p>
          </div>
          <div>
            <h2 className="font-heading uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight reveal" data-testid="host-headline">
              {HOST.headline1}
              <span className="text-[#6b9be8]">{HOST.headlineAccent}</span>
              {HOST.headline2}
            </h2>
            <div className="w-16 h-px bg-[#3f639f] my-8" />
            {HOST.paragraphs.map((p, i) => (
              <p key={i} className="text-[#aeb9d4] leading-relaxed mb-5 text-sm sm:text-base reveal">{p}</p>
            ))}
            <div className="grid sm:grid-cols-2 gap-px bg-[#1c2740] border border-[#1c2740] mt-8 reveal" data-testid="host-facts">
              {HOST.facts.map((f) => (
                <div key={f.k} className="bg-[#0c1324] p-5">
                  <p className="font-mono text-[9px] tracking-[0.3em] text-[#5c6a8c] uppercase mb-1.5">{f.k}</p>
                  <p className="text-white text-sm">{f.v}</p>
                </div>
              ))}
            </div>
            <button
              onClick={scrollToForm}
              data-testid="host-cta"
              className="cta-glow mt-8 flex items-center gap-2 bg-[#3f639f] hover:bg-[#4f76b8] text-white font-mono text-xs tracking-[0.25em] uppercase px-8 py-4 reveal"
            >
              <Check size={15} /> Reserve My Free Seat
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Host;
